import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

//helpers
import { formateDateApi } from "../../../helpers/formats.js";
import { ValidaEmail } from "../../../helpers/email";
import {
  onlyAlphaNumericAndSpace,
  onlyNumber,
} from "../../../helpers/valid.js";

// services
import {
  InputCEP,
  InputCNPJ,
  InputCPF,
  InputTELEFONE,
} from "../../../services/mask.js";
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import { isValidDate } from "../../../helpers/valid.js";
import {
  EnviaProtocoloWithProtocoloDestino,
  EnviaRequerimentoDestino,
} from "../../../services/protocolo_destino_service.js";
import { GetCEPViaCEP } from "../../../services/viaCep";

//Context
import { useAuth } from "../../../context/auth";

export default function Identificacao({
  item,
  tipoCadastro,
  permiteManutencao,
  handleProximoStep,
  handleReturn,
}) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setError, setValue, clearErrors } =
    useForm({ mode: "onBlur" });

  const [permiteEditar, set_permiteEditar] = React.useState(true);

  // Status
  const [status, set_status] = React.useState("");
  const [options_status] = React.useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Cancelado", label: "Cancelado" },
    { value: "Inativo", label: "Inativo" },
    { value: "Pendente", label: "Pendente" },
    { value: "Vencido", label: "Vencido" },
  ]);
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  };

  // E-Mail
  const [email, set_email] = React.useState("");
  const handleEmail = (event) => {
    if (event.target.value.length == 0) return;

    set_email(event.target.value);

    ValidaEmail(event.target.value, handleRetornoValidaEmail);
  };
  const handleRetornoValidaEmail = (result) => {
    if (result.status !== 200) {
      showMessage("Aviso", result.message, "error", null);
      set_email("");
    } else {
      if (!result.data) {
        showMessage("Aviso", "E-Mail inválido.", "error", null);
        setValue("email", "");
        set_email("");
      }
    }
  };

  // Nome Fantasia
  const handleFantasia = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("fantasia", result);
  };

  // Razão Social
  const handleRazaoSocial = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("razaoSocial", result);
  };

  // Nome do Solicitante
  const handleSolicitante = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("nomeSolicitante", result);
  };

  // Data Vigência
  const handleDataVigencia = (event) => {
    let input_date = event.target.value;

    if (input_date != "" || input_date.length > 0) {
      if (isValidDate(input_date) == false) {
        showMessage("Aviso", "Data de validade inválida.", "warning", null);
        return;
      }
    }
  };

  // Tipo de Pessoa
  const optionsTipoPessoa = [
    { value: "Física", label: "Pessoa Física" },
    { value: "Jurídica - MEI", label: "Pessoa Jurídica (MEI)" },
    { value: "Jurídica", label: "Pessoa Jurídica" },
  ];
  const [tipoPessoa, set_tipoPessoa] = useState("Jurídica");
  const handleTipoPessoa = (value) => {
    set_tipoPessoa(value.value);
    setValue("tipoPessoa", value.value, true);
    clearErrors("tipoPessoa");
  };

  // Licença de Operação
  const handleLicencaOperacao = (e) => {
    let result = onlyNumber(e.target.value);
    setValue("numeroLicensaOperacao", result);
  };

  // Número Endereço
  const handleNumeroEndereco = (e) => {
    let result = onlyNumber(e.target.value);
    setValue("numEndereco", result);
  };

  // cep
  const [editarEndereco, set_editarEndereco] = useState(true);
  const handleCEP = (event) => {
    clearErrors("cep");

    if (event.target.value.replace(/[^0-9]/g, "").trim().length < 8) {
      setValue("cep", "");
      showMessage(
        "Aviso",
        "Cep inválido. só é permitido preencher com números",
        "error",
        null
      );
      return;
    }

    GetCEPViaCEP(event.target.value).then((result) => {
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == true)
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
        set_editarEndereco(true);
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);

        if (
          result.data.logradouro == null ||
          result.data.logradouro.length == 0
        )
          set_editarEndereco(false);
        else set_editarEndereco(true);
      }
    });
  };

  // Categoria
  const [categoria, set_categoria] = useState(null);

  // Classes de Resíduo
  const [classesResiduo, set_classesResiduo] = useState([]);
  const [optionsClassesResiduo, set_OptionsClassesResiduo] = useState([]);
  const loadOptionsClassesResiduo = (categoria_Id) => {
    api_GET(`ClasseResiduo/GetListAtivosByCategoria/${categoria_Id}`)
      .then((result) => {
        set_OptionsClassesResiduo(result.data);
        if (tipoCadastro == "Protocolo") {
          if (
            item != null &&
            item.protocoloDestino.length > 0 &&
            item.protocoloDestino[0].protocoloDestinoClasseResiduos != null
          ) {
            let _classes = [];
            result.data.map((m) => {
              if (
                item.protocoloDestino[0].protocoloDestinoClasseResiduos.filter(
                  (f) => f.classeResiduo_Id == m.classeResiduo_Id
                ).length > 0
              )
                _classes.push(m);
            });
            set_classesResiduo(_classes);
          }
        } else if (tipoCadastro == "Requerimento") {
          if (
            item != null &&
            item.requerimentoDestino.length > 0 &&
            item.requerimentoDestino[0].requerimentoDestinoClasseResiduos !=
            null
          ) {
            let _classes = [];
            result.data.map((m) => {
              if (
                item.requerimentoDestino[0].requerimentoDestinoClasseResiduos.filter(
                  (f) => f.classeResiduo_Id == m.classeResiduo_Id
                ).length > 0
              )
                _classes.push(m);
            });
            set_classesResiduo(_classes);
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleClassesResiduo = (event) => {
    set_classesResiduo(event);
  };

  // Classes de Resíduo
  const [transportadores, set_transportadores] = useState([]);
  const [optionsTransportadores, set_optionsTransportadores] = useState([]);
  const loadOptionsTransportadores = () => {
    api_GET(`ProtocoloTransportador/GetListProtocoloTransportador`)
      .then((result) => {
        set_optionsTransportadores(result.data);
        if (tipoCadastro == "Protocolo") {
          if (
            item != null &&
            item.protocoloDestino.length > 0 &&
            item.protocoloDestino[0].protocoloDestinoTransportadores != null
          ) {
            let _transportadores = [];
            result.data.map((m) => {
              if (
                item.protocoloDestino[0].protocoloDestinoTransportadores.filter(
                  (f) =>
                    f.protocoloTransportador_Id == m.protocoloTransportador_Id
                ).length > 0
              )
                _transportadores.push(m);
            });
            set_transportadores(_transportadores);
          }
        } else if (tipoCadastro == "Requerimento") {
          if (
            item != null &&
            item.requerimentoDestino.length > 0 &&
            item.requerimentoDestino[0].requerimentoDestinoTransportadores !=
            null
          ) {
            let _transportadores = [];
            result.data.map((m) => {
              if (
                item.requerimentoDestino[0].requerimentoDestinoTransportadores.filter(
                  (f) =>
                    f.protocoloTransportador_Id == m.protocoloTransportador_Id
                ).length > 0
              )
                _transportadores.push(m);
            });
            set_transportadores(_transportadores);
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleTransportadores = (event) => {
    set_transportadores(event);
  };

  // Tipo de Destino
  const [tipoDestino, set_tipoDestino] = React.useState("");
  const [options_tipoDestino, set_optionsTipoDestino] = React.useState([]);

  const LoadTiposDestino = () => {
    if (
      (item.setupSolicitacaoAcao != null &&
        item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG") ||
      (item.setupSolicitacaoAcaoNovoCadastro != null &&
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
          .sigla == "RGG")
    ) {
      api_GET("TipoDestino")
        .then((result) => {
          let tipos = result.data.map((m, key) => ({
            label: m.tbTipoDestino_Descricao,
            value: m.tbTipoDestino_Descricao,
          }));
          set_optionsTipoDestino(tipos);
        })
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    } else {
      set_optionsTipoDestino([
        { value: "Área de Aterro", label: "Área de Aterro" },
        {
          value: "Área de Triagem e Transbordo",
          label: "Área de Triagem e Transbordo",
        },
        { value: "Área de Reciclagem", label: "Área de Reciclagem" },
        { value: "Outros Resíduos", label: "Outros Resíduos" },
      ]);
    }
  };

  const handleTipoDestino = (value) => {
    set_tipoDestino(value);
    setValue("tipoDestino", value, true);
    clearErrors("tipoDestino");
  };

  // Tipo de Destino
  const [comprovacaoDestinacao, set_comprovacaoDestinacao] =
    React.useState("Não");
  const [options_comprovacaoDestinacao] = React.useState([
    { value: "Não", label: "Não" },
    { value: "Sim", label: "Sim" },
  ]);
  const handleComprovacaoDestinacao = (value) => {
    set_comprovacaoDestinacao(value);
    setValue("comprovacaoDestinacao", value, true);
    clearErrors("comprovacaoDestinacao");
  };

  const loadItemRequerimento = () => {
    if (item != null) {
      setValue("email", item.email);
      set_email(item.email);
      setValue("cnpj", item.cpf_Cnpj);
      setValue("cpf", item.cpf_Cnpj);
      setValue("nomeSolicitante", item.nomeSolicitante);
      setValue(
        "responsavel",
        item.requerimentoDestino != null && item.requerimentoDestino.length > 0
          ? item.requerimentoDestino[0].nomeResponsavel
          : item.nomeSolicitante
      );
      set_categoria(item.setupSolicitacaoAcao.setupSolicitacao.categoria);
      loadOptionsClassesResiduo(
        item.setupSolicitacaoAcao.setupSolicitacao.categoria_Id
      );
      loadOptionsTransportadores();
      if (item.cpf_Cnpj.length == 11) set_tipoPessoa("Física");
      else set_tipoPessoa(item.setupSolicitacaoAcao.setupSolicitacao.pessoa);

      if (
        item.requerimentoDestino != null &&
        item.requerimentoDestino.length > 0
      ) {
        setValue("fantasia", item.requerimentoDestino[0].nome_Fantasia);
        setValue("razaoSocial", item.requerimentoDestino[0].razaoSocial);
        setValue(
          "inscricaoMunicipal",
          item.requerimentoDestino[0].inscricaoMunicipal
        );
        setValue("ccm", item.requerimentoDestino[0].ccm);
        setValue("telefone", item.requerimentoDestino[0].telefone);
        setValue("celular", item.requerimentoDestino[0].celular);
        setValue(
          "dataFimVigencia",
          item.dataFimVigencia != null
            ? formateDateApi(item.dataFimVigencia)
            : ""
        );
        setValue("cep", item.requerimentoDestino[0].cep);
        setValue("logradouro", item.requerimentoDestino[0].logradouro);
        setValue("bairro", item.requerimentoDestino[0].bairro);
        setValue("numEndereco", item.requerimentoDestino[0].numEndereco);
        setValue("complemento", item.requerimentoDestino[0].complemento);
        setValue("cidade", item.requerimentoDestino[0].cidade);
        setValue("uf", item.requerimentoDestino[0].uf);
        setValue("status", item.status, true);
        set_status(item.status);
        setValue(
          "numeroLicensaOperacao",
          item.requerimentoDestino[0].numeroLicensaOperacao
        );
        setValue("nomeResponsavelTecnico", item.requerimentoDestino[0]?.nomeResponsavelTecnico ?? "");
        set_tipoDestino(item.requerimentoDestino[0].tipoDestino);
        setValue("tipoDestino", item.requerimentoDestino[0].tipoDestino, true);
      }
    }
  };

  const loadItemProtocolo = () => {
    if (item != null) {
      setValue("email", item.email);
      set_email(item.email);
      setValue("cnpj", item.cpf_Cnpj);
      setValue("cpf", item.cpf_Cnpj);
      setValue("nomeSolicitante", item.nomeSolicitante);
      setValue(
        "responsavel",
        item.protocoloDestino != null && item.protocoloDestino.length > 0
          ? item.protocoloDestino[0].nomeResponsavel
          : item.nomeSolicitante
      );
      set_categoria(
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
      );
      loadOptionsClassesResiduo(
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria_Id
      );
      loadOptionsTransportadores();
      if (item.cpf_Cnpj.length == 11) set_tipoPessoa("Física");
      else set_tipoPessoa(item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.pessoa);

      if (item.protocoloDestino.length > 0) {
        setValue("fantasia", item.protocoloDestino[0].nome_Fantasia);
        setValue("razaoSocial", item.protocoloDestino[0].razaoSocial);
        setValue(
          "inscricaoMunicipal",
          item.protocoloDestino[0].inscricaoMunicipal
        );
        setValue("ccm", item.protocoloDestino[0].ccm);
        setValue("codigoCadastro", item.codigoCadastro);
        setValue("telefone", item.protocoloDestino[0].telefone);
        setValue("celular", item.protocoloDestino[0].celular);
        setValue(
          "dataFimVigencia",
          item.dataFimVigencia != null
            ? formateDateApi(item.dataFimVigencia)
            : ""
        );
        setValue("cep", item.protocoloDestino[0].cep);
        setValue("logradouro", item.protocoloDestino[0].logradouro);
        setValue("bairro", item.protocoloDestino[0].bairro);
        setValue("numEndereco", item.protocoloDestino[0].numEndereco);
        setValue("complemento", item.protocoloDestino[0].complemento);
        setValue("cidade", item.protocoloDestino[0].cidade);
        setValue("uf", item.protocoloDestino[0].uf);
        setValue("status", item.status, true);
        set_status(item.status);
        setValue(
          "numeroLicensaOperacao",
          item.protocoloDestino[0].numeroLicensaOperacao
        );
        setValue("nomeResponsavelTecnico", item.protocoloDestino[0]?.nomeResponsavelTecnico ?? "");
        setValue("observacao", item.protocoloDestino[0].observacaoManutencao);
        set_tipoDestino(item.protocoloDestino[0].tipoDestino);
        setValue("tipoDestino", item.protocoloDestino[0].tipoDestino, true);
        set_comprovacaoDestinacao(
          item.protocoloDestino[0].requerComprovacaoDestinacao == true
            ? "Sim"
            : "Não"
        );
        setValue(
          "comprovacaoDestinacao",
          item.protocoloDestino[0].requerComprovacaoDestinacao == true
            ? "Sim"
            : "Não",
          true
        );
      }
    }
  };

  const loadDefaultValues = (field) => {
    if (item == null) return "";

    if (tipoCadastro == "Protocolo") {
      switch (field) {
        case "Telefone":
          return item.protocoloDestino.length > 0
            ? item.protocoloDestino[0].telefone
            : "";
        case "Celular":
          return item.protocoloDestino.length > 0
            ? item.protocoloDestino[0].celular
            : "";
        case "CEP":
          return item.protocoloDestino.length > 0
            ? item.protocoloDestino[0].cep
            : "";
      }
    } else if (tipoCadastro == "Requerimento") {
      if (item.requerimentoDestino != null) {
        switch (field) {
          case "Telefone":
            return item.requerimentoDestino.length > 0
              ? item.requerimentoDestino[0].telefone
              : "";
          case "Celular":
            return item.requerimentoDestino.length > 0
              ? item.requerimentoDestino[0].celular
              : "";
          case "CEP":
            return item.requerimentoDestino.length > 0
              ? item.requerimentoDestino[0].cep
              : "";
        }
      }
    }
  };

  useEffect(() => {
    LoadTiposDestino();
    if (
      session != null &&
      session.tipoAcesso == "AreaRestrita" &&
      session.tipoAcesso == "AreaRestrita"
    )
      set_permiteEditar(false);
    if (tipoCadastro == "Protocolo") loadItemProtocolo();
    else if (tipoCadastro == "Requerimento") loadItemRequerimento();
  }, []);

  const onSubmit = (data) => {
    setLoading(true);

    if (email == null || email.length == 0) {
      setLoading(false);
      showMessage("Aviso", "E-Mail não informado", "error", null);
      return;
    }

    if (isValidDate(data.dataFimVigencia) == false) {
      setLoading(false);
      showMessage("Aviso", "Data de validade inválida.", "warning", null);
      return;
    }

    let numeroEndereco = onlyNumber(data.numEndereco);
    if (numeroEndereco.length == "") {
      setLoading(false);
      showMessage(
        "Aviso",
        "Número de endereço inválido, ou, não informado. Só é permitido o preenchimento de dígitos numéricos.",
        "warning",
        null
      );
      return;
    }

    if (permiteManutencao && tipoCadastro == "Protocolo") {
      let json = carregaJsonProtocolo(data);
      EnviaProtocoloWithProtocoloDestino(json, handleRetornoSubmit);
    } else if (tipoCadastro == "Requerimento") {
      let json = carregaJsonRequerimento(data);
      EnviaRequerimentoDestino(json, handleRetornoSubmit);
    } else {
      handleProximoStep(item);
    }
  };
  const carregaJsonRequerimento = (data) => {
    let requerimentoDestinoClasseResiduo = [];
    classesResiduo.map((m) => {
      requerimentoDestinoClasseResiduo.push({
        requerimentoDestinoClasseResiduo_Id: 0,
        requerimentoDestino_Id: item != null ? item.requerimentoDestino_Id : 0,
        classeResiduo_Id: m.classeResiduo_Id,
      });
    });

    let requerimentoDestinoTransportadores = [];
    transportadores.map((m) => {
      requerimentoDestinoTransportadores.push({
        requerimentoDestinoTransportador_Id: 0,
        requerimentoDestino_Id: item != null ? item.requerimentoDestino_Id : 0,
        protocoloTransportador_Id: m.protocoloTransportador_Id,
      });
    });

    let json_submit = {
      requerimentoDestino_Id:
        item != null &&
          item.requerimentoDestino != null &&
          item.requerimentoDestino.length > 0
          ? item.requerimentoDestino[0].requerimentoDestino_Id
          : 0,
      requerimento_Id: item != null ? item.requerimento_Id : 0,
      cpf_Cnpj:
        (tipoPessoa == "Jurídica" || tipoPessoa === "Jurídica - MEI" || tipoPessoa == "Pública")
          ? data.cnpj
            .replaceAll("/", "")
            .replaceAll(".", "")
            .replaceAll("-", "")
          : data.cpf.replaceAll(".", "").replaceAll("-", ""),
      nome_Fantasia: data.fantasia == null ? data.responsavel : data.fantasia,
      razaoSocial:
        data.razaoSocial == null ? data.responsavel : data.razaoSocial,
      nomeSolicitante:
        data.nomeSolicitante == null ? data.responsavel : data.nomeSolicitante,
      inscricaoMunicipal: data.inscricaoMunicipal,
      nomeResponsavel: data.responsavel,
      nomeResponsavelTecnico: data?.nomeResponsavelTecnico ?? "",
      cCM: data.ccm,
      cEP: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numEndereco: data.numEndereco,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uF: data.uf,
      telefone: data.telefone
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll(" ", ""),
      celular: data.celular
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll(" ", ""),
      numeroLicensaOperacao: data.numeroLicensaOperacao,
      tipoDestino: tipoDestino,
      requerimentoDestinoClasseResiduos: requerimentoDestinoClasseResiduo,
      requerimentoDestinoTransportadores: requerimentoDestinoTransportadores,
    };

    return json_submit;
  };
  const carregaJsonProtocolo = (data) => {
    let protocoloDestinoClasseResiduo = [];
    classesResiduo.map((m) => {
      protocoloDestinoClasseResiduo.push({
        protocoloDestinoClasseResiduo_Id: 0,
        protocoloDestino_Id: item != null ? item.protocoloDestino_Id : 0,
        classeResiduo_Id: m.classeResiduo_Id,
      });
    });

    let protocoloDestinoTransportadores = [];
    transportadores.map((m) => {
      protocoloDestinoTransportadores.push({
        protocoloDestinoTransportador_Id: 0,
        protocoloDestino_Id: item != null ? item.protocoloDestino_Id : 0,
        protocoloTransportador_Id: m.protocoloTransportador_Id,
      });
    });

    let json_submit = {
      protocolo_Id: item != null ? item.protocolo_Id : 0,
      numeroProtocolo: item != null ? item.numeroProtocolo : "",
      nomeSolicitante:
        data.nomeSolicitante == null ? data.responsavel : data.nomeSolicitante,
      email: data.email,
      cpf_Cnpj:
        (tipoPessoa == "Jurídica" || tipoPessoa === "Jurídica - MEI" || tipoPessoa == "Pública")
          ? data.cnpj
            .replaceAll("/", "")
            .replaceAll(".", "")
            .replaceAll("-", "")
          : data.cpf.replaceAll(".", "").replaceAll("-", ""),
      status: item != null && status == "" ? item.status : status,
      dataFimVigencia:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? data.dataFimVigencia
          : item.dataFimVigencia,
      usuarioCadastro_Id:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? session.usuario_Id
          : null,
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? session.usuario_Id
          : null,
      codigoCadastro:
        data != null && data.codigoCadastro != ""
          ? data.codigoCadastro
          : item != null && item.protocoloDestino.length > 0
            ? item.codigoCadastro
            : "0",
      etapaCadastro: 1,
      protocoloDestino: [
        {
          protocoloDestino_Id:
            item != null && item.protocoloDestino.length > 0
              ? item.protocoloDestino[0].protocoloDestino_Id
              : 0,
          protocolo_Id: item != null ? item.protocolo_Id : 0,
          cpf_Cnpj:
            (tipoPessoa == "Jurídica" || tipoPessoa === "Jurídica - MEI" || tipoPessoa == "Pública")
              ? data.cnpj
                .replaceAll("/", "")
                .replaceAll(".", "")
                .replaceAll("-", "")
              : data.cpf.replaceAll(".", "").replaceAll("-", ""),
          nome_Fantasia:
            data.fantasia == null ? data.responsavel : data.fantasia,
          razaoSocial:
            data.razaoSocial == null ? data.responsavel : data.razaoSocial,
          inscricaoMunicipal: data.inscricaoMunicipal,
          nomeResponsavel: data.responsavel,
          nomeResponsavelTecnico: data?.nomeResponsavelTecnico,
          cCM: data.ccm,
          cEP: data.cep.replace(/[^0-9]/g, ""),
          logradouro: data.logradouro,
          numEndereco: data.numEndereco,
          complemento: data.complemento,
          bairro: data.bairro,
          cidade: data.cidade,
          uF: data.uf,
          telefone: data.telefone
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", ""),
          celular: data.celular
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", ""),
          numeroLicensaOperacao: data.numeroLicensaOperacao,
          tipoDestino: data.tipoDestino,
          requerComprovacaoDestinacao:
            comprovacaoDestinacao == "Sim" ? true : false,
          bloquearRecebimentoCapacidadeExcedida:
            item.protocoloDestino.length > 0
              ? item.protocoloDestino[0].bloquearRecebimentoCapacidadeExcedida
              : 0,
          observacaoManutencao:
            session != null && session.tipoAcesso == "AreaRestrita"
              ? data.observacao
              : "",
          protocoloDestinoClasseResiduos: protocoloDestinoClasseResiduo,
          protocoloDestinoTransportadores: protocoloDestinoTransportadores,
        },
      ],
    };
    return json_submit;
  };

  const handleRetornoSubmit = (result) => {
    setLoading(false);
    handleProximoStep(result.data);
  };

  return (
    <>
      <div>
        <Card className={`card card-stats`}>
          <CardHeader>
            <Row>
              <Col md="12" className="text-right">
                <label className="text-danger">* Campos Obrigatórios</label>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <h2 className="titulo-solicitacao">Identificação </h2>
              <h6 Style={{ padding: 0, margin: 0 }} className="text-center">
                {categoria && categoria.descricao}
              </h6>
              <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
                <Row>
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Dados de Identificação
                      </h4>
                      <Row>
                        <Col md="3" lg="3">
                          <FormGroup>
                            <b>
                              <label>Tipo Pessoa</label>{" "}
                            </b>
                            <Select
                              options={optionsTipoPessoa}
                              name="tipoPessoa"
                              value={optionsTipoPessoa.find(
                                (obj) => obj.value === tipoPessoa
                              )}
                              onChange={(value) => handleTipoPessoa(value)}
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "tipoPessoa" },
                                  { required: false }
                                )
                              }
                              isDisabled={true}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">*</span> Nome Responsável
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="responsavel"
                              innerRef={register({ required: permiteEditar })}
                              maxLength="50"
                              autoComplete="off"
                            />
                            {errors.responsavel && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>
                                Nome Responsável Técnico (CREA)
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="nomeResponsavelTecnico"
                              innerRef={register({ required: permiteEditar })}
                              maxLength="100"
                              autoComplete="off"
                            />
                            {errors.nomeResponsavelTecnico && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="5">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>Email
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="email"
                              onBlur={handleEmail}
                              innerRef={register({ required: permiteEditar })}
                              maxLength="200"
                              autoComplete="off"
                            />
                            {errors.email && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(tipoPessoa == "Jurídica" || tipoPessoa === "Jurídica - MEI" || tipoPessoa == "Pública") && (
                          <Col md="6">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">* </span> Nome
                                  Fantasia{" "}
                                  <a href="#" id="questionNomeFantasia">
                                    <i className="fas fa-question-circle"></i>
                                  </a>
                                  <UncontrolledTooltip
                                    target="questionNomeFantasia"
                                    placement="top"
                                  >
                                    Caso a empresa não tenha Nome Fantasia,
                                    informe a Razão Social
                                  </UncontrolledTooltip>
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="fantasia"
                                id="fantasia"
                                onKeyUp={handleFantasia}
                                innerRef={register({ required: true })}
                                maxLength="100"
                                autoComplete="off"
                              />
                              {errors.fantasia && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        {(tipoPessoa == "Jurídica" || tipoPessoa === "Jurídica - MEI" || tipoPessoa == "Pública") && (
                          <Col md="6">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">* </span> Razão
                                  Social{" "}
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="razaoSocial"
                                id="razaoSocial"
                                onBlur={handleRazaoSocial}
                                innerRef={register({ required: true })}
                                maxLength="100"
                                autoComplete="off"
                              />
                              {errors.razaoSocial && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        <Col md="12">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>Nome
                                Solicitante{" "}
                                <a href="#" id="questionNomeSolicitante">
                                  <i className="fas fa-question-circle"></i>
                                </a>
                                <UncontrolledTooltip
                                  target="questionNomeSolicitante"
                                  placement="top"
                                >
                                  Nome que aparecerá na tela inicial.
                                </UncontrolledTooltip>
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="nomeSolicitante"
                              id="nomeSolicitante"
                              onKeyUp={handleSolicitante}
                              innerRef={register({ required: true })}
                              maxLength="50"
                              autoComplete="off"
                            />
                            {errors.nomeSolicitante && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(tipoPessoa === "Jurídica" || tipoPessoa === "Jurídica - MEI" || tipoPessoa == "Pública") && (
                          <Col md="3">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> CNPJ
                                </label>
                              </b>
                              <InputCNPJ
                                name="cnpj"
                                defaultValue={item != null && item.cpf_Cnpj}
                                inputRef={register({ required: permiteEditar })}
                                readOnly={true}
                                autoComplete="off"
                              />
                              {errors.cnpj && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        {tipoPessoa == "Física" && (
                          <Col md="3">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> CPF
                                </label>
                              </b>
                              <InputCPF
                                name="cpf"
                                defaultValue={item != null && item.cpf_Cnpj}
                                inputRef={register({ required: permiteEditar })}
                                readOnly={true}
                                autoComplete="off"
                              />
                              {errors.cpf && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">*</span> Inscrição
                                Municipal{" "}
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="inscricaoMunicipal"
                              id="inscricaoMunicipal"
                              innerRef={register({ required: true })}
                              maxLength="100"
                              autoComplete="off"
                            />
                            {errors.inscricaoMunicipal && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>
                                CCM{" "}
                                <a href="#" id="questionCCM">
                                  <i className="fas fa-question-circle"></i>
                                </a>
                                <UncontrolledTooltip
                                  target="questionCCM"
                                  placement="top"
                                >
                                  Cadastro de Contribuintes Mobiliários (Se seu
                                  município não tiver essa informação, deixe o
                                  campo em branco)
                                </UncontrolledTooltip>
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="ccm"
                              innerRef={register({ required: false })}
                              maxLength="10"
                              autoComplete="off"
                              onChange={(event) =>
                                setValue(
                                  "ccm",
                                  event.target.value.replace(/\D/g, "")
                                )
                              }
                            />
                          </FormGroup>
                        </Col>
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Número Cadastro</label>
                                </b>
                                <Input
                                  type="text"
                                  name="codigoCadastro"
                                  innerRef={register({ required: true })}
                                  maxLength="10"
                                />
                                {errors.codigoCadastro && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <span className="text-danger">* </span>
                              <label>Telefone</label>
                            </b>
                            <InputTELEFONE
                              type="text"
                              name="telefone"
                              defaultValue={loadDefaultValues("Telefone")}
                              inputRef={register({ required: permiteEditar })}
                            />
                            {errors.telefone && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>Celular</label>
                            </b>
                            <InputTELEFONE
                              type="text"
                              name="celular"
                              defaultValue={loadDefaultValues("Celular")}
                              inputRef={register({ required: false })}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>Licença de Operação</label>
                            </b>
                            <Input
                              type="text"
                              name="numeroLicensaOperacao"
                              innerRef={register({ required: false })}
                              maxLength="10"
                              autoComplete="off"
                              onChange={handleLicencaOperacao}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">*</span> Tipo de
                                Destino
                              </label>
                            </b>
                            <Select
                              options={options_tipoDestino}
                              name="tipoDestino"
                              onChange={(e) => {
                                handleTipoDestino(e.value);
                              }}
                              getOptionLabel={({ label }) => label}
                              getOptionValue={({ value }) => value}
                              value={
                                tipoDestino != "" &&
                                options_tipoDestino.find(
                                  (obj) => obj.value === tipoDestino
                                )
                              }
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "tipoDestino" },
                                  { required: permiteEditar }
                                )
                              }
                            />
                            {errors.tipoDestino && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null &&
                          item.setupSolicitacaoAcao != null &&
                          item.setupSolicitacaoAcao.setupSolicitacao.categoria
                            .sigla != "RGG") ||
                          (item.setupSolicitacaoAcaoNovoCadastro != null &&
                            item.setupSolicitacaoAcaoNovoCadastro
                              .setupSolicitacao.categoria.sigla != "RGG" && (
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>
                                      {" "}
                                      Comprovação de Destinação{" "}
                                      <a
                                        href="#"
                                        id="questionComprovacaoDestinacao"
                                      >
                                        <i className="fas fa-question-circle"></i>
                                      </a>
                                      <UncontrolledTooltip
                                        target="questionComprovacaoDestinacao"
                                        placement="top"
                                      >
                                        O Transportador deve confirmar os dados
                                        do destino ao montar a CTR no Coletas
                                        RCC
                                      </UncontrolledTooltip>
                                    </label>
                                  </b>
                                  <Select
                                    options={options_comprovacaoDestinacao}
                                    name="comprovacaoDestinacao"
                                    onChange={(e) => {
                                      handleComprovacaoDestinacao(e.value);
                                    }}
                                    getOptionLabel={({ label }) => label}
                                    getOptionValue={({ value }) => value}
                                    value={
                                      comprovacaoDestinacao != "" &&
                                      options_comprovacaoDestinacao.find(
                                        (obj) =>
                                          obj.value === comprovacaoDestinacao
                                      )
                                    }
                                    placeholder="Selecione"
                                    ref={(e) =>
                                      register(
                                        { name: "comprovacaoDestinacao" },
                                        { required: permiteEditar }
                                      )
                                    }
                                  />
                                  {errors.comprovacaoDestinacao && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                            ))}
                        <Col md="12" lg="12">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">*</span> Classe de
                                Resíduos
                              </label>{" "}
                            </b>
                            <Select
                              options={optionsClassesResiduo}
                              getOptionLabel={({ descricao }) => descricao}
                              getOptionValue={({ classeResiduo_Id }) =>
                                classeResiduo_Id
                              }
                              name="classeResiduo"
                              isMulti={true}
                              value={optionsClassesResiduo.filter(
                                ({ classeResiduo_Id }) =>
                                  classesResiduo.filter(
                                    (f) =>
                                      f.classeResiduo_Id == classeResiduo_Id
                                  ).length > 0
                              )}
                              onChange={(value) =>
                                handleClassesResiduo(value || [])
                              }
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "classeResiduo" },
                                  { required: false }
                                )
                              }
                            />
                            {errors.classeResiduo && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {categoria != null &&
                          categoria.classificacao == "Banco Manejo" && (
                            <Col md="12" lg="12">
                              <FormGroup>
                                <b>
                                  <label>
                                    <span className="text-danger">*</span>{" "}
                                    Transportadores Liberados
                                  </label>{" "}
                                </b>
                                <Select
                                  options={optionsTransportadores}
                                  getOptionLabel={({ nome_Fantasia }) =>
                                    nome_Fantasia
                                  }
                                  getOptionValue={({
                                    protocoloTransportador_Id,
                                  }) => protocoloTransportador_Id}
                                  name="transportadores"
                                  isMulti={true}
                                  value={optionsTransportadores.filter(
                                    ({ protocoloTransportador_Id }) =>
                                      transportadores.filter(
                                        (f) =>
                                          f.protocoloTransportador_Id ==
                                          protocoloTransportador_Id
                                      ).length > 0
                                  )}
                                  onChange={(value) =>
                                    handleTransportadores(value || [])
                                  }
                                  placeholder="Selecione"
                                  ref={(e) =>
                                    register(
                                      { name: "transportadores" },
                                      { required: false }
                                    )
                                  }
                                />
                                {errors.transportadores && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Validade</label>
                                </b>
                                <Input
                                  type="date"
                                  name="dataFimVigencia"
                                  innerRef={register({ required: true })}
                                  onBlur={handleDataVigencia}
                                />
                                {errors.dataFimVigencia && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Status</label>
                                </b>
                                <Select
                                  options={options_status}
                                  name="status"
                                  onChange={(e) => {
                                    handleStatus(e.value);
                                  }}
                                  getOptionLabel={({ label }) => label}
                                  getOptionValue={({ value }) => value}
                                  value={
                                    status != "" &&
                                    options_status.find(
                                      (obj) => obj.value === status
                                    )
                                  }
                                  placeholder="Selecione"
                                  ref={(e) =>
                                    register(
                                      { name: "status" },
                                      { required: permiteEditar }
                                    )
                                  }
                                />
                                {errors.status && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="12">
                              <FormGroup>
                                <b>
                                  <label>Observações</label>
                                </b>
                                <Input
                                  type="textarea"
                                  name="observacao"
                                  innerRef={register({ required: false })}
                                />
                              </FormGroup>
                            </Col>
                          )}
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Endereço
                      </h4>
                      <Form>
                        <Row>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> CEP
                                </label>
                              </b>
                              <InputCEP
                                name="cep"
                                defaultValue={loadDefaultValues("CEP")}
                                onBlur={handleCEP}
                                inputRef={register({ required: permiteEditar })}
                              />
                              {errors.cep && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="5" lg="5">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>{" "}
                                  Logradouro
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="logradouro"
                                maxLength="100"
                                innerRef={register({ required: permiteEditar })}
                              />
                              {errors.logradouro && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="4" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> Bairro
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="bairro"
                                maxLength="50"
                                innerRef={register({ required: permiteEditar })}
                              />
                              {errors.bairro && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="2" lg="2">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> Número
                                </label>
                              </b>
                              <Input
                                type="number"
                                name="numEndereco"
                                innerRef={register({ required: permiteEditar })}
                                onChange={handleNumeroEndereco}
                              />
                              {errors.numEndereco && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>Complemento</label>
                              </b>
                              <Input
                                type="text"
                                name="complemento"
                                innerRef={register({ required: false })}
                                maxLength="50"
                              />
                            </FormGroup>
                          </Col>
                          <Col md="5" lg="5">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> Cidade
                                </label>
                              </b>
                              <Input
                                type="text"
                                readonly="readonly"
                                name="cidade"
                                innerRef={register({ required: permiteEditar })}
                                maxLength="50"
                              />
                              {errors.cidade && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="2" lg="2">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> UF
                                </label>
                              </b>
                              <Input
                                type="text"
                                readonly="readonly"
                                name="uf"
                                innerRef={register({ required: permiteEditar })}
                                maxLength="2"
                              />
                              {errors.uf && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                  <Col md="6">
                    {session != null &&
                      session.tipoAcesso == "AreaRestrita" &&
                      session.usuario_Id != null && (
                        <Button
                          color="secundary"
                          onClick={handleReturn}
                          className="btn-mobile"
                          type="submit"
                        >
                          <i className="fas fa-chevron-left"></i> Voltar
                        </Button>
                      )}
                  </Col>
                  <Col md="6" className="text-right">
                    <Button
                      color="success"
                      className="btn-mobile"
                      type="submit"
                    >
                      Próxima Etapa <i className="fas fa-chevron-right"></i>
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
